export default "__VITE_ASSET__91265a9f__"